import axios from 'axios';
import { getAccessToken, isAuthenticated } from '../application-center/login-center/lib/authentication';

axios.interceptors.request.use(async request => {
  const appToken = getAccessToken();

  if (appToken) {
    if (isAuthenticated()) {
      // with valid token time

      const headers = {
        appToken: appToken,
        'Content-Type': 'application/json',
      };

      request.headers = {
        ...request.headers,
        ...headers,
      };

      /*request.data = {
        ...request.data,
        // for future customization
      };*/

      return request;
    } else {
      window.location.href = '/logout?exp=to';
      throw new axios.Cancel();
    }
  } else {
    // for other purpose, eg: login, log, parameters
    const headers = {
      'Content-Type': 'application/json',
    };

    request.headers = {
      ...request.headers,
      ...headers,
    };

    request.data = {
      ...request.data,
      // for future customization
    };

    return request;
  }
}, undefined);

axios.interceptors.response.use(
  response => {
    // console.log("success response", response.config);
    return response;
  },
  async failedResponse => {
    if (failedResponse.response?.status === 401) {
      throw new axios.Cancel();
    }
    return Promise.reject(failedResponse);
  },
);
